import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, mergeMap, of } from 'rxjs'

import { show_error_action } from '../action/common/common.action'
import { DashboardInfoAPIModel } from 'src/models/api.model'
import { FETCH_DASHBOARD_INFO, FETCH_DASHBOARD_INFO_SUCCESS } from '../action/dashboard.action'
import { DashboardService } from 'src/services/dashboard/dashboard.service'

@Injectable()
export class DashboardEffects {
  constructor(private actions$: Actions, private dashboardService: DashboardService) {}

  fetch_dashboard_info$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_DASHBOARD_INFO),
      mergeMap(action =>
        this.dashboardService.callGetDashboardInfoApi().pipe(
          mergeMap((response: DashboardInfoAPIModel) => [FETCH_DASHBOARD_INFO_SUCCESS({ dashboardInfo: response })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
